<script setup>
import SidenavWithSubmenu from "./SidenavWithSubmenu.vue";

import { useMenuStore } from "@/Store/menu.js";

import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";

const props = defineProps({
    menu: Object,
    showIcon: {
        type: Boolean,
        default: true,
    },
    unreadCounts: Object,
    badgeKeyForMenu: Object,
    getBadgeCount: Function,
    shouldBadge: Function,
    getTotalChildrenBadges: Function,
    shouldShowParentBadge: Function,
    isLoading: {
        type: Boolean,
        default: false,
    },
});

const route = useRoute();
const activeMenu = ref(false);
const menuStore = useMenuStore();
const topmenuActive = computed(() => menuStore.topmenuActive);

const activeMenuCode = computed(() => {
    return route.path.split("/")[1] ?? "";
});

const defineActiveMenu = () => {
    for (let menuChildren of props.menu.children) {
        if (activeMenuCode.value == menuChildren.code) {
            menuStore.setMenu(props.menu.parent_id);
            activeMenu.value = true;
        }
    }
};

defineActiveMenu();

watch(activeMenuCode, (newValue) => {
    activeMenu.value = false;
    defineActiveMenu();
});
</script>

<template>
    <a
        class="nav-link d-flex align-items-center"
        :class="{
            active: activeMenu || topmenuActive == menu.id,
            collapsed: !activeMenu,
        }"
        href="#"
        data-bs-toggle="collapse"
        :data-bs-target="'#collapseLayouts' + menu.id"
        aria-expanded="false"
        :aria-controls="'collapseLayouts' + menu.id"
    >
        <div class="sb-nav-link-icon" v-if="showIcon">
            <span class="material-icons">
                {{ menu.icon }}
            </span>
        </div>

        <span>{{ menu.name }}</span>

        <span
            v-if="shouldShowParentBadge && shouldShowParentBadge(menu)"
            class="badge bg-danger ms-auto"
            :class="{ 'opacity-50': isLoading }"
        >
            {{ getTotalChildrenBadges(menu) }}
        </span>

        <div
            class="sb-sidenav-collapse-arrow"
            :class="{
                'ms-auto':
                    !shouldShowParentBadge || !shouldShowParentBadge(menu),
            }"
        >
            <i class="fas fa-angle-down"></i>
        </div>
    </a>
    <div
        class="collapse"
        :class="{
            show: activeMenu || topmenuActive == menu.id,
        }"
        :id="'collapseLayouts' + menu.id"
        aria-labelledby="headingOne"
        :data-bs-parent="
            menu.parent_id != 0
                ? '#sidenavAccordionPage' + menu.parent_id
                : '#sidenavAccordion'
        "
    >
        <nav
            class="sb-sidenav-menu-nested nav"
            :id="'sidenavAccordionPage' + menu.id"
        >
            <template
                v-for="childrenMenu in menu.children"
                :key="childrenMenu.id"
            >
                <RouterLink
                    v-if="childrenMenu.type == 0"
                    class="nav-link d-flex align-items-center"
                    :class="{
                        active: activeMenuCode == childrenMenu.code,
                        'ps-5': !showIcon,
                    }"
                    :to="{ name: childrenMenu.code }"
                    preserve-state
                >
                    <span>{{ childrenMenu.name }}</span>

                    <span
                        v-if="shouldBadge && shouldBadge(childrenMenu.code)"
                        class="badge bg-danger ms-auto"
                        :class="{ 'opacity-50': isLoading }"
                    >
                        {{ getBadgeCount(childrenMenu.code) }}
                    </span>
                </RouterLink>

                <SidenavWithSubmenu
                    v-if="childrenMenu.type == 2"
                    :menu="childrenMenu"
                    :showIcon="false"
                    :unreadCounts="unreadCounts"
                    :badgeKeyForMenu="badgeKeyForMenu"
                    :getBadgeCount="getBadgeCount"
                    :shouldBadge="shouldBadge"
                    :getTotalChildrenBadges="getTotalChildrenBadges"
                    :shouldShowParentBadge="shouldShowParentBadge"
                    :isLoading="isLoading"
                />
            </template>
        </nav>
    </div>
</template>
